export default "__VITE_ASSET__C2tak_oN__"